
import { useState } from 'react';

interface DealTermsProps {
  terms: string[];
  expiresAt: string;
}

export default function DealTerms({ terms, expiresAt }: DealTermsProps) {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50/50 transition-colors"
      >
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-file-list-3-line text-teal-600 text-base"></i>
          </div>
          Terms &amp; Conditions
        </h2>
        <div className="w-6 h-6 flex items-center justify-center">
          <i
            className={`ri-arrow-down-s-line text-gray-400 text-xl transition-transform duration-300 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          ></i>
        </div>
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isExpanded ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 pb-6">
          {expiresAt !== 'Ongoing' && (
            <div className="flex items-center gap-2 mb-4 px-3 py-2 bg-amber-50 rounded-lg border border-amber-100">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-alarm-warning-line text-amber-600 text-sm"></i>
              </div>
              <span className="text-xs font-semibold text-amber-700">
                This offer expires on {expiresAt}
              </span>
            </div>
          )}

          <ul className="space-y-3">
            {terms.map((term, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[10px] font-bold text-gray-500">{idx + 1}</span>
                </div>
                <span className="text-sm text-gray-600 leading-relaxed">{term}</span>
              </li>
            ))}
          </ul>

          <p className="text-[11px] text-gray-400 mt-5 pt-4 border-t border-gray-100 leading-relaxed">
            This deal is provided by the business and is subject to change without notice.
            Roseville.org is not responsible for the fulfillment of this offer. Please contact
            the business directly with any questions.
          </p>
        </div>
      </div>
    </div>
  );
}
